import { Header } from '@tanstack/react-table';

interface DataTableResizerProps<TData> {
  header: Header<TData, unknown>;
}

/**
 * @deprecated This component is deprecated and will be removed in a future version.
 * Please use AppTable component instead.
 * @see src/components/app-table
 */

export function DataTableResizer<TData>({
  header,
}: DataTableResizerProps<TData>) {
  if (header.column.getCanResize() === false) return null;

  return (
    <div
      {...{
        onDoubleClick: () => header.column.resetSize(),
        onMouseDown: (e) => {
          e.preventDefault();
          header.getResizeHandler()(e);
        },
        onTouchStart: (e) => {
          e.preventDefault();
          header.getResizeHandler()(e);
        },
        className: `absolute top-0 opacity-0 bg-primary/50 hover:opacity-100 right-0 h-full z-[10000] w-[5px] cursor-col-resize user-select-none touch-action-none ${
          header.column.getIsResizing() ? 'isResizing' : ''
        }`,
      }}
    />
  );
}
